export class ChangePhoneNumberResendOtpRequest {
    sessionToken: string = '';
}